import React from 'react'
import Accordion from '../accordion'

import type { Props } from './tabordion'

type TabordionAccordionProps = {
  id: Props['id']
  items: Props['items']
  accordionContainerClassName: Props['accordionContainerClassName']
  activeTabs: number[]
  toggleItem: (tab: number) => void
  noContentPadding: Props['noContentPadding']
  accordionClassName: Props['accordionClassName']
  accordionFirstandLastBorder: Props['accordionFirstandLastBorder']
}
export default function TabordionAccordion({
  id,
  items,
  accordionContainerClassName,
  activeTabs,
  toggleItem,
  noContentPadding,
  accordionClassName,
  accordionFirstandLastBorder,
}: TabordionAccordionProps) {
  return (
    <div id={id} className={accordionContainerClassName}>
      {items.map((item, i) => (
        <Accordion
          key={i}
          id={item.id}
          title={item.title}
          extState
          extOpen={activeTabs.includes(i)}
          setExtOpen={() => toggleItem(i)}
          noPanelPadding={noContentPadding}
          className={accordionClassName}
          firstAndLastBorder={accordionFirstandLastBorder}
          stickyScrollTo={true}
          href={item.href}
          sticky={true}>
          {item.content ? (
            item.content
          ) : (
            <div className={noContentPadding ? 'u-px-16 u-py-16' : ''}>{item.noContentText}</div>
          )}
        </Accordion>
      ))}
    </div>
  )
}
